<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="d-flex p-3 background-primary-blue height-70px shadow z-max align-items-center">
        <app-back-button/>
        <div class="m-auto d-flex gap-3 justify-content-center align-items-center color-white">
            <div class="col-auto fs-main text-center">Unassigned tags</div>
            <div class="d-flex align-items-center gap-1">
                <img src="icons/tag.svg" class="icon"/>
                <span>{{ deviceStore.unassignedTags().length }}</span>
            </div>
        </div>
        <app-close-button/>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="tags">
            @for (tag of deviceStore.unassignedTags(); track tag.id) {
                <app-unassigned-tag-button [id]="tag.id" class="tag"/>
            }
        </div>
    </div>
</div>
